import { Col, List, Row, Skeleton } from "antd";
import { SubmitButton, TextComponent } from "../../../../../components";
import styles from "./ToDoChecklist.module.css";
import { memo, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RiDeleteBinLine } from "react-icons/ri";
import { BiSolidEdit } from "react-icons/bi";
import Modal from "../../../../../components/modal/Modal";
import { MdDelete } from "react-icons/md";
import TaskList from "../TaskList/TaskList";
import { CheckListMiddleware } from "../../../../../Store/Middlewares/CheckListMiddleware";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

const RenderItem = memo(({ info, selectedDate, setSelectedDate }) => {
  const classes =
    selectedDate === info
      ? `${styles.selectedDateRow} ${styles.dateRow}`
      : `${styles.dateRow}`;
  return (
    <List.Item style={{ padding: "0 10px" }}>
      <Row className={classes} onClick={() => setSelectedDate(info)}>
        <Col xs={7} lg={5}>
          <TextComponent
            text={moment(info).format("DD")}
            textClass={styles.date}
          />
        </Col>
        <Col xs={17} lg={19}>
          <TextComponent
            text={moment(info).format("dddd")}
            textClass={styles.day}
          />
        </Col>
      </Row>
    </List.Item>
  );
});

const DaysList = ({ selectedDate, setSelectedDate, dates }) => {
  const navigate = useNavigate();

  const { state } = useLocation();
  console.log("dates", dates);
  return (
    <>
      <Row className={styles.leftHeaderRow}>
        <TextComponent textClass={styles.leftColTitle}>This Week</TextComponent>
        <TextComponent
          textClass={styles.leftColLink}
          onClick={() =>
            navigate("/events/calendar", {
              state: { headrTitle: "Calendar", eventData: state?.eventData },
            })
          }
        >
          View Calendar
        </TextComponent>
      </Row>
      <List
        grid={{
          xs: 1,
          sm: 2,
          md: 2,
          lg: 1,
          xl: 1,
          xxl: 1,
        }}
        dataSource={dates?.length > 0 ? dates : []}
        renderItem={(info) => (
          <RenderItem
            info={info}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        )}
      />
    </>
  );
};

const ToDoChecklist = ({ addTaskBtn, showDueDate, status }) => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [loading, setloading] = useState(true);
  const ChecklistData = useSelector(
    status == "weekly"
      ? (state) => state.EventReducer.Weekly_CheckList
      : (state) => state.EventReducer.Monthly_CheckList
  );
  // const [ChecklistData, setChecklistData] = useState(true);
  const [selectedDate, setSelectedDate] = useState();
  const [selectedCheckList, setselectedCheckList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getChecklist();
  }, []);

  const getChecklist = () => {
    setloading(true);
    dispatch(
      CheckListMiddleware.getCheckList({
        status: status ? status : null,
        id: state?.id,
      })
    )
      .then((data) => {
        if (data?.dates?.length > 0) {
          setSelectedDate(data?.dates?.[0]);
        }
        setloading(false);
      })
      .catch(() => {
        setloading(false);
      });
  };

  console.log("ChecklistData", ChecklistData);
  console.log("selectedCheckList", selectedCheckList);

  useEffect(() => {
    if (ChecklistData?.dates?.length > 0) {
      let checkList = ChecklistData?.checklists?.filter(
        (data) => data?.date == selectedDate?.split(" ")[0]
      );
      setselectedCheckList(checkList);
    } else {
      setselectedCheckList([]);
    }
  }, [selectedDate, ChecklistData]);

  return (
    <Skeleton loading={loading}>
      <Row className={styles.row} gutter={{ xs: 0, lg: 24 }}>
        <Col xs={24} lg={8} xl={6}>
          <DaysList
            dates={ChecklistData?.dates}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        </Col>
        <Col xs={24} lg={16} xl={18}>
          <Row className={styles.rightHeaderRow}>
            <Col>
              <TextComponent textClass={styles.selectedDate}>
                {moment(selectedDate).format("dddd, MMM DD, YYYY")}
              </TextComponent>
            </Col>
            <Col>
              <Row className={styles.statusContainer}>
                {/* <Row className={styles.statusRow}>
                  <Col className={styles.primaryDot}></Col>
                  <Col>
                    <TextComponent>
                      Done ({ChecklistData?.done ? ChecklistData?.done : "0"})
                    </TextComponent>
                  </Col>
                </Row> */}
                <Row className={styles.statusRow}>
                  <Col className={styles.secondaryDot}></Col>
                  <Col>
                    <TextComponent>
                      To Do ({ChecklistData?.todo ? ChecklistData?.todo : "0"})
                    </TextComponent>
                  </Col>
                  {status != "pending" && (
                    <>
                      <Col className={styles.secondaryDot}></Col>
                      <Col>
                        <TextComponent>
                          Done (
                          {ChecklistData?.done ? ChecklistData?.done : "0"})
                        </TextComponent>
                      </Col>
                    </>
                  )}
                </Row>
              </Row>
              {addTaskBtn && (
                <SubmitButton
                  title="Add New Task"
                  btnClass={styles.btn}
                  onClick={() =>
                    navigate("/events/eventDetail/addNewTask", {
                      state: {
                        headrTitle: "Add New Task",
                        eventData: state?.eventData,
                      },
                    })
                  }
                />
              )}
            </Col>
          </Row>
          <TaskList
            tasks={selectedCheckList}
            showDueDate={showDueDate}
            status={status}
          />
        </Col>
      </Row>
    </Skeleton>
  );
};

export default ToDoChecklist;
